export const setDateRange = (state, payload) => {
  state.dateRange = payload
}
export const setAccountEntries = (state, payload) => {
  state.accountEntries = payload
}
export const setGateCampingReport = (state, payload) => {
  state.gateCampingReport = payload
}
export const setGateParkingReport = (state, payload) => {
  state.gateParkingReport = payload
}
export const setCampgroundReport = (state, payload) => {
  state.campgroundReport = payload
}
export const setCampsiteReport = (state, payload) => {
  state.campsiteReport = payload
}
export const setParkingReport = (state, payload) => {
  state.parkingReport = payload
}
export const setGatePassReport = (state, payload) => {
  state.gatePassReport = payload
}
export const setInvoiceSourceReport = (state, payload) => {
  state.invoiceSourceReport = payload
}
export const setGeneratedReport = (state, payload) => {
  state.generatedReport = payload
}
export const setErrorLog = (state, payload) => {
  state.errorLog = payload
}
